import { useEffect, useState } from 'react';
import { PageTitle } from '../../../_metronic/layout/core';
import styleScss from './styles.module.scss';
import { Link } from 'react-router-dom';
import UseDidMountEffect from '../../modules/auth/core/UseDidMountEffect';
import Button from '@mui/material/Button';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import DownloadIcon from '@mui/icons-material/Download';
import AddTaskIcon from '@mui/icons-material/AddTask';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import AddBoxIcon from '@mui/icons-material/AddBox';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import Checkbox from '@mui/material/Checkbox';
import { Alert, Snackbar, AlertTitle, Typography } from '@mui/material';
import { useAuth } from '../../modules/auth';
import { concatArrayToStringJoinBy, initValue, truncateWords } from '../../util/Index';
import { LinearLoadingSpinner, LoadingBackdrop } from '../../components/LoadingSpinner/LoadingSpinner';
import BackButton from '../../components/BackButton/BackButton';
import { StatusAccompanimentModel } from '../../models/StatusAccompanimentModel'
import {
    getCompanies,
    downloadZipAllFilesByCompany,
    deleteEmpresaById,
    updateStatusEmpresa,
    updateEmpresaToActive,
    updateEmpresaToDesactive,
    getAccompaniment,
    deleteAcompaniment,
    putStatusAcompaniment,
    getListOfCalls,
    deleteConvocatoria,
    getParticipantesDeLaConvocatoria,
    getCetificadosDeUnaConvocatoria,
    getUnSoloCertificadoDeUnaConvocatoria
} from '../../modules/apps/user-management/users-list/core/_requests';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Tooltip,
    TablePagination,
    Stack,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
    FormControl,
    CircularProgress,
    Select,
    InputLabel
} from '@mui/material';

import DatePicker from "react-multi-date-picker";
import dayjs from 'dayjs';
import { useParams } from "react-router-dom";

interface StatusCompanyProps {
    id: number;
    status?: string;
    observaciones?: string;
}

const ListPaticipantes = () => {
    const { id } = useParams();
    const [accionesActivas, setAccionesActivas] = useState(false);
    const { isAdminRole, isCounselorEmployerRole, isEmployerRole } = useAuth();
    const [selectedDates, setSelectedDates] = useState<any>([]);
    const [data, setData]: any[] = useState([]);
    const [userData, setUserData]: any[] = useState([]);
    const [companyData, setCompanyData] = useState<StatusCompanyProps>({ id: 0 });
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setSubmitting] = useState(false);
    const [open, setOpen] = useState(false);
    const [idConvocatoria, setIdConvocatoria] = useState();
    const [alert, setAlert] = useState(true);
    const [alertMsg, setAlertMsg] = useState('');
    const [selectedCertificates, setSelectedCertificates] = useState<number[]>([]);
    const [massDownloadMode, setMassDownloadMode] = useState(false);

    /* Pagination */
    const [total, setTotal] = useState<number>(0);
    const [filter, setFilter] = useState<any>({
        page: 1,
        limit: 10,
        estado: ''
    });
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    useEffect(() => {
        handleGetParticipantes();
    }, [filter.page, filter.limit]);

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
        setFilter((prev : any) => ({ ...prev, page: newPage + 1 })); 
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);
        setFilter((prev : any) => ({ ...prev, limit: newRowsPerPage, page: 1 }));
    };

    const handleFirstPageButtonClick = () => {
        setPage(0);
        setFilter((prev : any) => ({ ...prev, page: 1 }));
    };

    const handleLastPageButtonClick = () => {
        const lastPage = Math.ceil(total / rowsPerPage) - 1;
        setPage(lastPage);
        setFilter((prev : any) => ({ ...prev, page: lastPage + 1 }));
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleGetParticipantes = async () => {
        setLoading(true);
        const params = {
            convocatoria_id: id,
            page: filter.page,
            limit: filter.limit
        };
        try {
            const response = await getParticipantesDeLaConvocatoria(params);
            if (response && response.data) {
                setTotal(response.data.total);
                setData(response.data.data);
            }
        } catch (error: any) {
            if (error.response) {
                console.error(error.response.data.error);
            } else {
                console.error('Ocurrio un error procesando la solicitud.');
            }
        } finally {
            setLoading(false);
        }
    };

    const toggleMassDownloadMode = () => {
        setMassDownloadMode(!massDownloadMode);
        if (!massDownloadMode) {
            setSelectedCertificates([]);
        }
    };

    const handleCertificateSelection = (id: number, isSelected: boolean) => {
        if (isSelected) {
            setSelectedCertificates(prev => [...prev, id]);
        } else {
            setSelectedCertificates(prev => prev.filter(certId => certId !== id));
        }
    };

    const handleSelectAllCertificates = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const allApprovedIds = data
                .filter((x: any) => x?.aprobado !== 'No' && x?.aprobado !== 'Reprobado')
                .map((x: any) => x.id);
            setSelectedCertificates(allApprovedIds);
        } else {
            setSelectedCertificates([]);
        }
    };

    const handleMassDownload = async () => {
        if (selectedCertificates.length === 0) return;
        
        setLoading(true);
        try {
            const blob = await getCetificadosDeUnaConvocatoria(id, selectedCertificates);
            
            /* Crear una URL para el archivo blob */
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `certificados_seleccionados_${new Date().toISOString().slice(0, 10)}.zip`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            setOpen(true);
            setAlert(true);
            setAlertMsg('Descarga masiva iniciada');
            setTimeout(() => setOpen(false), 2000);
        } catch (error: any) {
            setOpen(true);
            setAlert(false);
            setAlertMsg(error.response?.data?.error || 'Error al descargar los certificados');
            setTimeout(() => setOpen(false), 4000);
        } finally {
            setLoading(false);
        }
    };

    const handleDescargarUnSoloCertificado = async (idUsuario: any) => {
        try {
            const res = await getUnSoloCertificadoDeUnaConvocatoria(idUsuario, id);
            if (res.type === 'application/pdf') {
                const url = window.URL.createObjectURL(res);
                const link = document.createElement('a');
                link.href = url;
                link.download = `certificado_${idUsuario}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } else {
                console.error('El archivo no es un PDF');
            }
        } catch (error: any) {
            console.error('Error al descargar:', error);
        }
    };

    return (
        <>
            <div className='p-4 shadow-4 rounded-3 mt-15' style={{ backgroundColor: '#FFFF' }}>
                <LoadingBackdrop loading={isSubmitting} />
                <div className='row mb-4' style={{ alignItems: 'center' }}>
                    <div className='col-sm-12'>
                        <div className='input-group d-flex' style={{ width: '100%', alignItems: 'baseline' }}>
                            <div style={{ padding: '10px 0px 0px 15px' }}>
                                <div className='col-xs-2 col-sm-1 col-md-1'
                                    style={{
                                        display: 'contents',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }} >
                                    <BackButton />
                                </div>
                            </div>
                            
                            <div style={{ marginLeft: '10px' }}>
                                <Button 
                                    variant="contained" 
                                    endIcon={!massDownloadMode && <DownloadIcon />} 
                                    size="large" 
                                    onClick={toggleMassDownloadMode}
                                    color={massDownloadMode ? 'error' : 'primary'}
                                >
                                    {massDownloadMode ? 'CANCELAR SELECCIÓN' : 'DESCARGA MASIVA DE CERTIFICADOS'}
                                </Button>
                            </div>
                            
                            {massDownloadMode && (
                                <div style={{ marginLeft: '10px' }}>
                                    <Button 
                                        variant="contained" 
                                        endIcon={<FileDownloadIcon />} 
                                        size="large" 
                                        onClick={handleMassDownload}
                                        disabled={selectedCertificates.length === 0}
                                        color="primary"
                                    >
                                        DESCARGAR SELECCIONADOS ({selectedCertificates.length})
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {loading && <LinearLoadingSpinner isLoading={loading} />}

                <div className={`${styleScss['table-limit']}`} style={{ maxWidth: '100%', overflowWrap: 'break-word', overflowY: 'hidden' }}>
                    <Stack padding={2}>
                        <TableContainer component={Paper} style={{ overflowY: 'visible', overflowWrap: 'break-word' }}>
                            <Table style={{ overflowY: 'visible' }}>
                                <TableHead className={`${styleScss['th-custom']}`}>
                                    <TableRow>
                                        {massDownloadMode && (
                                            <TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
                                                <Checkbox
                                                    onChange={handleSelectAllCertificates}
                                                    indeterminate={
                                                        selectedCertificates.length > 0 && 
                                                        selectedCertificates.length < data.filter((x: any) => x?.aprobado !== 'No' && x?.aprobado !== 'Reprobado').length
                                                    }
                                                    checked={
                                                        selectedCertificates.length > 0 && 
                                                        selectedCertificates.length === data.filter((x: any) => x?.aprobado !== 'No' && x?.aprobado !== 'Reprobado').length
                                                    }
                                                />
                                            </TableCell>
                                        )}
                                        <TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
                                            <h4>Tipo de documento</h4>
                                        </TableCell>
                                        <TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
                                            <h4>Número de documento</h4>
                                        </TableCell>
                                        <TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
                                            <h4>Primer nombre</h4>
                                        </TableCell>
                                        <TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
                                            <h4>Segundo nombre</h4>
                                        </TableCell>
                                        <TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
                                            <h4>Primer apellido</h4>
                                        </TableCell>
                                        <TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
                                            <h4>Segundo apellido</h4>
                                        </TableCell>
                                        <TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
                                            <h4>Aprobado</h4>
                                        </TableCell>
                                        <TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
                                            <h4>Razón de no aprobación</h4>
                                        </TableCell>
                                        <TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
                                            <h4>Certificado</h4>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                {!loading && <TableBody>
                                    {data.map((x: any, i: any) => (
                                        <TableRow key={i} id={i.toString()}>
                                            {massDownloadMode && (
                                                <TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>
                                                    {x?.aprobado !== 'No' && x?.aprobado !== 'Reprobado' ? (
                                                        <Checkbox
                                                            checked={selectedCertificates.includes(x.id)}
                                                            onChange={(e) => handleCertificateSelection(x.id, e.target.checked)}
                                                        />
                                                    ) : (
                                                        <Tooltip title="Este participante no aprobó el curso" arrow>
                                                            <span>
                                                                <Checkbox disabled />
                                                            </span>
                                                        </Tooltip>
                                                    )}
                                                </TableCell>
                                            )}
                                            <TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>
                                                {x?.aspiranteUser?.UserComplemento?.tipo_doc || 'N/A'}
                                            </TableCell>
                                            <TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>
                                                {x?.aspiranteUser?.UserComplemento?.numero_doc || 'N/A'}
                                            </TableCell>
                                            <TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>
                                                {x?.aspiranteUser?.UserComplemento?.primer_nome || 'N/A'}
                                            </TableCell>
                                            <TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>
                                                {x?.aspiranteUser?.UserComplemento?.segundo_nome || 'N/A'}
                                            </TableCell>
                                            <TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>
                                                {x?.aspiranteUser?.UserComplemento?.primer_apelido || 'N/A'}
                                            </TableCell>
                                            <TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>
                                                {x?.aspiranteUser?.UserComplemento?.segundo_apelido || 'N/A'}
                                            </TableCell>
                                            <TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>
                                                {x?.aprobado || 'N/A'}
                                            </TableCell>
                                            <TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>
                                                {x?.razon_no_aprobacion || 'N/A'}
                                            </TableCell>
                                            <TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>
                                                {x?.aprobado !== 'No' && x?.aprobado !== 'Reprobado' ? (
                                                    <IconButton 
                                                        aria-label="delete" 
                                                        size="large" 
                                                        onClick={() => handleDescargarUnSoloCertificado(x.id)}
                                                    >
                                                        <DownloadIcon fontSize="inherit" />
                                                    </IconButton>
                                                ) : (
                                                    <Tooltip title='¡No es posible descargar el certificado dado que el asistente no aprobó el curso!' placement='left' arrow>
                                                        <span> 
                                                            <IconButton aria-label="delete" size="large" disabled>
                                                                <HorizontalRuleIcon fontSize="inherit" />
                                                            </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>}

                                {data.length === 0 && (
                                    <tfoot>
                                        <TableRow>
                                            <TableCell colSpan={massDownloadMode ? 11 : 10}>
                                                <p className='text-center' style={{ width: '100%', textAlign: 'center' }}>
                                                    No se encontraron registros
                                                </p>
                                            </TableCell>
                                        </TableRow>
                                    </tfoot>
                                )}
                            </Table>
                            <div style={{ fontFamily: 'Poppins', fontSize: '14.5px' }}>
                                <TablePagination
                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                    component="div"
                                    style={{ overflow: 'visible', fontFamily: 'Poppins', fontSize: '14.5px' }}
                                    count={total}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    labelRowsPerPage="Filas por página:"
                                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                                    ActionsComponent={({ onPageChange, count, page, rowsPerPage }) => (
                                        <div style={{ display: 'flex', alignItems: 'center', fontFamily: 'Poppins', fontSize: '14.5px' }}>
                                            <IconButton 
                                                onClick={handleFirstPageButtonClick} 
                                                disabled={page === 0} 
                                                aria-label="first page"
                                            >
                                                <FirstPageIcon />
                                            </IconButton>
                                            <IconButton 
                                                onClick={() => onPageChange(null, page - 1)} 
                                                disabled={page === 0} 
                                                aria-label="previous page"
                                            >
                                                <ChevronLeftIcon />
                                            </IconButton>
                                            <IconButton 
                                                onClick={() => onPageChange(null, page + 1)} 
                                                disabled={page >= Math.ceil(count / rowsPerPage) - 1} 
                                                aria-label="next page"
                                            >
                                                <ChevronRightIcon />
                                            </IconButton>
                                            <IconButton 
                                                onClick={handleLastPageButtonClick} 
                                                disabled={page >= Math.ceil(count / rowsPerPage) - 1} 
                                                aria-label="last page"
                                            >
                                                <LastPageIcon />
                                            </IconButton>
                                        </div>
                                    )}
                                />
                            </div>
                        </TableContainer>
                    </Stack>
                </div>
            </div>

            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={open}
                onClose={handleClose}
            >
                <Alert
                    onClose={handleClose}
                    variant={'filled'}
                    severity={alert ? 'success' : 'error'}
                    sx={{ whiteSpace: 'pre-line' }}
                >
                    {alert ? <AlertTitle>Éxito</AlertTitle> : <AlertTitle>Error</AlertTitle>}
                    {alertMsg}
                </Alert>
            </Snackbar>
        </>
    );
};

const DownloadCertificates = () => {
    return (
        <>
            <PageTitle breadcrumbs={[]}>Listado de certificados</PageTitle>
            <ListPaticipantes />
        </>
    );
};

export { DownloadCertificates };